import React from 'react';
import styled from 'styled-components';
import { HELP_LIST_TRACK_CAT, hidden } from '../util';
import { FaqCategoryView } from './HelpListCategory';
import { screenMdMax, screenSmMax, screenSmMin, screenXsMax, screenXsMin, spacer24, spacer32, spacer48 } from '@spotify-internal/encore-foundation/web';
import { HelpListSideMenu } from './HelpListSideMenu';
import { Type } from '@spotify-internal/encore-web';
import { FaqArticleView } from './HelpListArticle';
import { ButtonSecondaryAsLink } from '../../ui';
import { getBurst } from '../../utils';
import { contentPadding } from './common';
import { itemToSearchHit } from '../../Search';
import { FAQItem, Variant } from '../HelpFAQ/FAQItem';
import { useLocale, useT } from '@mrkt/features/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Container = styled.div.withConfig({
  displayName: "HelpList__Container",
  componentId: "jn1xwp-0"
})(["display:flex;flex-flow:row nowrap;width:100%;min-height:calc(100vh - 76px);margin-top:10px;@media (max-width:", "){min-height:calc(100vh - 68px);margin-top:2px;}@media (max-width:", "){display:block;}"], screenSmMax, screenSmMin);
var SideMenuContainer = styled.div.withConfig({
  displayName: "HelpList__SideMenuContainer",
  componentId: "jn1xwp-1"
})(["flex:1;display:flex;flex-flow:column nowrap;max-width:350px;padding:", " ", ";color:", ";background:", ";@media (max-width:", "){", "}"], spacer32, spacer24, function (_ref) {
  var theme = _ref.theme;
  return theme.help.sideMenu.text;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.help.sideMenu.background;
}, screenSmMin, hidden);
var ContentContainer = styled.div.withConfig({
  displayName: "HelpList__ContentContainer",
  componentId: "jn1xwp-2"
})(["flex:2;display:flex;flex-flow:column;justify-content:space-between;overflow-x:hidden;background:", ";color:", ";@media (max-width:", "){min-height:calc(100vh - 50px);}@media (max-width:", "){min-height:calc(100vh - ", ");}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.box.background;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.box.text;
}, screenSmMin, screenXsMin, spacer48);
var Banner = styled.div.withConfig({
  displayName: "HelpList__Banner",
  componentId: "jn1xwp-3"
})(["flex:1;display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:center;width:100%;max-height:250px;min-height:221px;", ";background-color:", ";color:", ";", " background-position:right center;background-repeat:no-repeat;background-size:contain;@media (max-width:", "){background-image:none;flex-flow:column;justify-content:space-evenly;}"], contentPadding, function (_ref5) {
  var theme = _ref5.theme;
  return theme.help.banner.background;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.help.banner.text;
}, function (_ref7) {
  var theme = _ref7.theme;
  return getBurst(theme.help.banner.text);
}, screenMdMax);
var BannerText = styled(Type.h2).attrs({
  variant: 'heading2',
  weight: Type.book
}).withConfig({
  displayName: "HelpList__BannerText",
  componentId: "jn1xwp-4"
})(["padding-bottom:0px;line-height:0;@media (max-width:", "){line-height:revert;}"], screenMdMax);
var ContactUsButton = styled(ButtonSecondaryAsLink).withConfig({
  displayName: "HelpList__ContactUsButton",
  componentId: "jn1xwp-5"
})(["background-color:", ";color:", ";border:0;white-space:nowrap;&&:hover:not(:disabled),&:focus:not(:disabled),&:active:not(:disabled){color:", ";border:0;}@media (max-width:", "){width:100%;}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.help.banner.text;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.help.banner.ctaText;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.help.banner.background;
}, screenSmMax);
var RelatedContent = styled.div.withConfig({
  displayName: "HelpList__RelatedContent",
  componentId: "jn1xwp-6"
})(["flex:1;width:100%;", ";background-color:", ";@media (max-width:", "){flex:0;}"], contentPadding, function (_ref11) {
  var theme = _ref11.theme;
  return theme.help.grayBox.background;
}, screenXsMax);
var RelatedContentTitle = styled(Type.h3).attrs({
  variant: Type.heading3,
  weight: Type.bold
}).withConfig({
  displayName: "HelpList__RelatedContentTitle",
  componentId: "jn1xwp-7"
})(["font-size:", ";"], spacer32);
export var HelpList = function HelpList(template) {
  var _currentArticle$relat;

  var t = useT();
  var locale = useLocale();
  var faqCategories = template.faqCategories,
      currentCategory = template.currentCategory,
      currentArticle = template.currentArticle;
  var related = currentArticle === null || currentArticle === void 0 ? void 0 : (_currentArticle$relat = currentArticle.related) === null || _currentArticle$relat === void 0 ? void 0 : _currentArticle$relat.map(function (item) {
    return itemToSearchHit(item, locale);
  }).filter(Boolean).map(function (hit) {
    return /*#__PURE__*/_jsx(React.Fragment, {
      children: /*#__PURE__*/_jsx(FAQItem, {
        hit: hit,
        variant: Variant.RELATED
      })
    }, hit.url);
  });
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(SideMenuContainer, {
      "data-testid": "help-list-nav",
      children: /*#__PURE__*/_jsx(HelpListSideMenu, {
        categories: faqCategories,
        currentCategory: currentCategory
      })
    }), /*#__PURE__*/_jsxs(ContentContainer, {
      "data-testid": "help-list-content",
      children: [currentArticle ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FaqArticleView, {
          article: currentArticle,
          category: currentCategory
        }), related && related.length > 0 ? /*#__PURE__*/_jsxs(RelatedContent, {
          children: [/*#__PURE__*/_jsx(RelatedContentTitle, {
            children: t('FRODOR_HELP_LIST_RELATED_CONTENT', 'Related content', 'Content that is related to the current article')
          }), related]
        }) : null]
      }) : /*#__PURE__*/_jsx(FaqCategoryView, {
        category: currentCategory
      }), /*#__PURE__*/_jsxs(Banner, {
        "data-testid": "help-list-banner",
        children: [/*#__PURE__*/_jsx(BannerText, {
          children: t('FRODOR_HELP_LIST_CANT_FIND', "Can't find what you're looking for?", '')
        }), /*#__PURE__*/_jsx(ContactUsButton, {
          href: "/contact",
          track: [HELP_LIST_TRACK_CAT, 'Contact us'],
          children: t('FRODOR_HELP_LIST_CONTACT_US', 'Contact us', '')
        })]
      })]
    })]
  });
};